//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { navs } from './route';

export default {
  data() {
    return {
      navs: []
    };
  },

  created() {
    this.navs = navs;
  }
};



// WEBPACK FOOTER //
// ./example/demos.vue